module.exports = __webpack_public_path__ + "img/BGMain6.daf25011.jpg";